import React, { useEffect, useRef } from "react";

// "Restore unsaved work?" prompt (DI-1). Shown on startup when a local
// draft exists; the coach always chooses — nothing is restored
// automatically. Test IDs are the E2E contract in e2e/README.md.
const describeSavedAt = (ms) => {
  if (!ms) return null;
  try {
    return new Date(ms).toLocaleString(undefined, {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      day: "numeric",
      month: "short",
    });
  } catch {
    return null;
  }
};

export const DraftRestoreDialog = ({ draft, onRestore, onDiscard }) => {
  const restoreRef = useRef(null);
  useEffect(() => {
    if (draft && restoreRef.current) restoreRef.current.focus();
  }, [draft]);

  if (!draft) return null;

  const count = draft.tabs.length;
  const when = describeSavedAt(draft.savedAt);
  const sessionName = (draft.sessionName || "").trim();

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/40 p-4">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="draft-restore-title"
        aria-describedby="draft-restore-desc"
        data-testid="draft-restore-dialog"
        className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 shadow-lg"
      >
        <h2
          id="draft-restore-title"
          className="text-lg font-bold tracking-tight text-slate-900"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Restore unsaved work?
        </h2>
        <p id="draft-restore-desc" className="mt-2 text-sm text-slate-600 leading-snug">
          This device has unsaved {sessionName ? <>changes to <strong>{sessionName}</strong></> : "work"}:{" "}
          {count} activit{count === 1 ? "y" : "ies"}
          {when ? <>, last edited {when}</> : null}.
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onDiscard}
            data-testid="draft-restore-discard"
            className="h-9 px-4 rounded-md border border-slate-200 bg-white text-sm font-semibold text-slate-700 hover:bg-slate-100 transition-colors"
          >
            Discard
          </button>
          <button
            type="button"
            ref={restoreRef}
            onClick={onRestore}
            data-testid="draft-restore-accept"
            className="h-9 px-4 rounded-md bg-slate-900 text-sm font-semibold text-white hover:bg-slate-800 transition-colors"
          >
            Restore
          </button>
        </div>
      </div>
    </div>
  );
};
